/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationPurposeBase,
  DonationPurposeBaseOptional,
  DonationPurposeBaseMetaI,
  DonationPurposeBaseTrackedI,
} from "./donation-purpose-base";
import {
  DonationPurposeBaseTracked,
  DonationPurposeBaseMeta,
} from "./donation-purpose-base";

/**
 *
 * @export
 * @interface DonationFundBase
 */
export interface DonationFundBaseOptional extends DonationPurposeBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof DonationFundBase
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFundBase
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundBase
   */
  showInCheckout?: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFundBase
   */
  portalDescription?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFundBase
   */
  imageURL?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFundBase
   */
  fundName?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFundBase
   */
  letterText?: string;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundBase
   */
  isEndowment?: boolean;
}

export interface DonationFundBase
  extends DonationFundBaseOptional, DonationPurposeBase {
  /**
   *
   * @type {boolean}
   * @memberof DonationFundBase
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFundBase
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundBase
   */
  showInCheckout?: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFundBase
   */
  portalDescription?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFundBase
   */
  imageURL?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFundBase
   */
  fundName?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFundBase
   */
  letterText?: string;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundBase
   */
  isEndowment?: boolean;
}

export interface DonationFundBaseTrackedI extends DonationPurposeBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof DonationFundBase
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFundBase
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundBase
   */
  showInCheckout?: boolean;
  showInCheckoutIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFundBase
   */
  portalDescription?: string;
  portalDescriptionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFundBase
   */
  imageURL?: string;
  imageURLIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFundBase
   */
  fundName?: string;
  fundNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFundBase
   */
  letterText?: string;
  letterTextIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundBase
   */
  isEndowment?: boolean;
  isEndowmentIsSet: boolean;
}

transformDatesMap.set(
  "DonationFundBase",
  function (model: DonationFundBase) {},
);

export type DonationFundBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  showInCheckout: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  portalDescription: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  imageURL: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  fundName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  letterText: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isEndowment: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var DonationFundBaseMeta: DonationFundBaseMetaI =
  {} as DonationFundBaseMetaI;
DonationFundBaseMeta = typeMeta("DonationFundBase", {
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  showInCheckout: propertyMeta(
    "showInCheckout",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  portalDescription: propertyMeta(
    "portalDescription",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  imageURL: propertyMeta("imageURL", false, false, false, MetaTypesBase.string),
  fundName: propertyMeta("fundName", false, false, false, MetaTypesBase.string),
  letterText: propertyMeta(
    "letterText",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isEndowment: propertyMeta(
    "isEndowment",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = DonationFundBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DonationPurposeBaseMeta]);
  metaI.active.inheritedFrom = DonationPurposeBaseMeta.active;
  metaI.displayOrder.inheritedFrom = DonationPurposeBaseMeta.displayOrder;
  metaI.showInCheckout.inheritedFrom = DonationPurposeBaseMeta.showInCheckout;
  metaI.portalDescription.inheritedFrom =
    DonationPurposeBaseMeta.portalDescription;
  metaI.imageURL.inheritedFrom = DonationPurposeBaseMeta.imageURL;
});

export class DonationFundBaseTracked
  extends DonationPurposeBaseTracked
  implements DonationFundBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  showInCheckout__I?: boolean = undefined;
  showInCheckoutIsSet: boolean = false;
  set showInCheckout(v: undefined | boolean) {
    if (v !== undefined) {
      this.showInCheckout__I = v;
      this.showInCheckoutIsSet = true;
    } else {
      this.showInCheckout__I = v || undefined;
      this.showInCheckoutIsSet = false;
    }
    this.changeTracker = true;
  }
  get showInCheckout() {
    return this.showInCheckout__I;
  }
  portalDescription__I?: string = undefined;
  portalDescriptionIsSet: boolean = false;
  set portalDescription(v: undefined | string) {
    if (v !== undefined) {
      this.portalDescription__I = v;
      this.portalDescriptionIsSet = true;
    } else {
      this.portalDescription__I = v || undefined;
      this.portalDescriptionIsSet = false;
    }
    this.changeTracker = true;
  }
  get portalDescription() {
    return this.portalDescription__I;
  }
  imageURL__I?: string = undefined;
  imageURLIsSet: boolean = false;
  set imageURL(v: undefined | string) {
    if (v !== undefined) {
      this.imageURL__I = v;
      this.imageURLIsSet = true;
    } else {
      this.imageURL__I = v || undefined;
      this.imageURLIsSet = false;
    }
    this.changeTracker = true;
  }
  get imageURL() {
    return this.imageURL__I;
  }
  fundName__I?: string = undefined;
  fundNameIsSet: boolean = false;
  set fundName(v: undefined | string) {
    if (v !== undefined) {
      this.fundName__I = v;
      this.fundNameIsSet = true;
    } else {
      this.fundName__I = v || undefined;
      this.fundNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get fundName() {
    return this.fundName__I;
  }
  letterText__I?: string = undefined;
  letterTextIsSet: boolean = false;
  set letterText(v: undefined | string) {
    if (v !== undefined) {
      this.letterText__I = v;
      this.letterTextIsSet = true;
    } else {
      this.letterText__I = v || undefined;
      this.letterTextIsSet = false;
    }
    this.changeTracker = true;
  }
  get letterText() {
    return this.letterText__I;
  }
  isEndowment__I?: boolean = undefined;
  isEndowmentIsSet: boolean = false;
  set isEndowment(v: undefined | boolean) {
    if (v !== undefined) {
      this.isEndowment__I = v;
      this.isEndowmentIsSet = true;
    } else {
      this.isEndowment__I = v || undefined;
      this.isEndowmentIsSet = false;
    }
    this.changeTracker = true;
  }
  get isEndowment() {
    return this.isEndowment__I;
  }
  constructor(config?: DonationFundBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: DonationFundBaseOptional,
    options?: AssignOptions,
  ): DonationFundBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (
      config.showInCheckout &&
      this.showInCheckoutApplyFilter(optionsRequired.filter)
    ) {
      this.showInCheckout = config.showInCheckout;
      if (optionsRequired.unassign) this.showInCheckoutIsSet = false;
      else this.showInCheckoutIsSet = true;
    }
    if (
      config.portalDescription &&
      this.portalDescriptionApplyFilter(optionsRequired.filter)
    ) {
      this.portalDescription = config.portalDescription;
      if (optionsRequired.unassign) this.portalDescriptionIsSet = false;
      else this.portalDescriptionIsSet = true;
    }
    if (config.imageURL && this.imageURLApplyFilter(optionsRequired.filter)) {
      this.imageURL = config.imageURL;
      if (optionsRequired.unassign) this.imageURLIsSet = false;
      else this.imageURLIsSet = true;
    }
    if (config.fundName && this.fundNameApplyFilter(optionsRequired.filter)) {
      this.fundName = config.fundName;
      if (optionsRequired.unassign) this.fundNameIsSet = false;
      else this.fundNameIsSet = true;
    }
    if (
      config.letterText &&
      this.letterTextApplyFilter(optionsRequired.filter)
    ) {
      this.letterText = config.letterText;
      if (optionsRequired.unassign) this.letterTextIsSet = false;
      else this.letterTextIsSet = true;
    }
    if (
      config.isEndowment &&
      this.isEndowmentApplyFilter(optionsRequired.filter)
    ) {
      this.isEndowment = config.isEndowment;
      if (optionsRequired.unassign) this.isEndowmentIsSet = false;
      else this.isEndowmentIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DonationFundBaseTrackedI {
    const cloned = {} as DonationFundBaseTrackedI;
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.showInCheckoutIsSetDeep() &&
      this.showInCheckoutApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.showInCheckoutIsSet = true;
      cloned.showInCheckout = this.showInCheckout;
    } else {
      //cloned.showInCheckoutIsSet = false
    }
    if (
      this.portalDescriptionIsSetDeep() &&
      this.portalDescriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.portalDescriptionIsSet = true;
      cloned.portalDescription = this.portalDescription;
    } else {
      //cloned.portalDescriptionIsSet = false
    }
    if (
      this.imageURLIsSetDeep() &&
      this.imageURLApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.imageURLIsSet = true;
      cloned.imageURL = this.imageURL;
    } else {
      //cloned.imageURLIsSet = false
    }
    if (
      this.fundNameIsSetDeep() &&
      this.fundNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.fundNameIsSet = true;
      cloned.fundName = this.fundName;
    } else {
      //cloned.fundNameIsSet = false
    }
    if (
      this.letterTextIsSetDeep() &&
      this.letterTextApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.letterTextIsSet = true;
      cloned.letterText = this.letterText;
    } else {
      //cloned.letterTextIsSet = false
    }
    if (
      this.isEndowmentIsSetDeep() &&
      this.isEndowmentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isEndowmentIsSet = true;
      cloned.isEndowment = this.isEndowment;
    } else {
      //cloned.isEndowmentIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DonationFundBaseTrackedI {
    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.showInCheckoutApplyFilter(filter))
      this.showInCheckoutIsSet = false;

    if (!this.portalDescriptionApplyFilter(filter))
      this.portalDescriptionIsSet = false;

    if (!this.imageURLApplyFilter(filter)) this.imageURLIsSet = false;

    if (!this.fundNameApplyFilter(filter)) this.fundNameIsSet = false;

    if (!this.letterTextApplyFilter(filter)) this.letterTextIsSet = false;

    if (!this.isEndowmentApplyFilter(filter)) this.isEndowmentIsSet = false;

    return this;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundBaseMeta.active,
      DonationFundBaseMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundBaseMeta.displayOrder,
      DonationFundBaseMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  showInCheckoutApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundBaseMeta.showInCheckout,
      DonationFundBaseMeta,
      this.showInCheckout,
      this,
    );
  }
  showInCheckoutIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.showInCheckoutIsSet && this.showInCheckoutApplyFilter(filter))
      return true;

    return false;
  }
  portalDescriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundBaseMeta.portalDescription,
      DonationFundBaseMeta,
      this.portalDescription,
      this,
    );
  }
  portalDescriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.portalDescriptionIsSet &&
      this.portalDescriptionApplyFilter(filter)
    )
      return true;

    return false;
  }
  imageURLApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundBaseMeta.imageURL,
      DonationFundBaseMeta,
      this.imageURL,
      this,
    );
  }
  imageURLIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.imageURLIsSet && this.imageURLApplyFilter(filter)) return true;

    return false;
  }
  fundNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundBaseMeta.fundName,
      DonationFundBaseMeta,
      this.fundName,
      this,
    );
  }
  fundNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.fundNameIsSet && this.fundNameApplyFilter(filter)) return true;

    return false;
  }
  letterTextApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundBaseMeta.letterText,
      DonationFundBaseMeta,
      this.letterText,
      this,
    );
  }
  letterTextIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.letterTextIsSet && this.letterTextApplyFilter(filter)) return true;

    return false;
  }
  isEndowmentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundBaseMeta.isEndowment,
      DonationFundBaseMeta,
      this.isEndowment,
      this,
    );
  }
  isEndowmentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isEndowmentIsSet && this.isEndowmentApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.showInCheckoutIsSetDeep(filter)) return true;
    if (this.portalDescriptionIsSetDeep(filter)) return true;
    if (this.imageURLIsSetDeep(filter)) return true;
    if (this.fundNameIsSetDeep(filter)) return true;
    if (this.letterTextIsSetDeep(filter)) return true;
    if (this.isEndowmentIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
